module.exports = __webpack_public_path__ + "img/pen.c6d829ff.png";